export default __webpack_public_path__ + "static/media/synthesis-sample-transfer.0917bd7e.svg";